import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from "@angular/core";
import { SvgIconModule } from "../../components/svg-icon/svg-icon.module";
import { DeviceService, PositionService } from "../../providers";
import { CommonModule } from '@angular/common';

enum DeviceType {
    DESKTOP = 'DESKTOP',
    IOS = 'IOS',
    ANDROID = 'ANDROID',
    UNKNOWN = 'UNKNOWN'
}

@Component({
    selector: 'location-help',
    templateUrl: 'location-help.html',
    styleUrls: ['./location-help.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: true,
    imports: [ CommonModule, SvgIconModule ],
})
export class LocationHelpComponent implements OnInit {
    @Output() close = new EventEmitter<void>()

    public bgLoaded = false;
    public device: DeviceType = DeviceType.UNKNOWN;
    public isSafari: boolean = false;

    // Export to view
    public DeviceType = DeviceType;

    constructor(
        private positionService: PositionService,
        private deviceService: DeviceService) {}

    ngOnInit(): void {
        // Detect device type to show device specific GPS help instructions
        if(this.deviceService.isIos()) {
            this.device = DeviceType.IOS;
        }
        else if(this.deviceService.isAndroid()) {
            this.device = DeviceType.ANDROID;
        }
        else {
            this.device = DeviceType.DESKTOP;
            // Check if this is safari browser
            this.isSafari = this.deviceService.isSafari();
        }
    }

    public enableLocation() {
        this.positionService.init();
        this.close.emit();
    }
}
